import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import CalendarItem from '@calendar/components/View/CalendarItem.vue'
import WebMailBottom from '@/components/common/WebMailBottom.vue'
import { mapGetters } from 'vuex'
import * as types from '@calendar/store/types'
import * as dateutil from '@/util/date-helper';
@Component({
    components: { CalendarItem, WebMailBottom },
    computed: {
        ...mapGetters({
            monthMatrix: types.CALENDAR_MONTH_MATRIX_LIST,
            weekMatrix: types.CALENDAR_WEEK_MATRIX_LIST,
            currentDate: types.COMMON_DATE_CURRENT,
        })
    },
})
export default class WeekView extends Vue {
    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    dayWrap: HTMLDivElement | undefined;

    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //
    
    monthMatrix!: Array<Array<calendar.DateItem>>
    weekMatrix!: Array<Array<calendar.DateItem>>
    currentDate!: calendar.DateItem

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: C O M P U T E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    get weekDisplay() {
        return this.monthMatrix[0].map((x) => {
            return {
                text: dateutil.uGetWeekArray([
                    this.$t('W_Schedule_Sun').toString(),
                    this.$t('W_Schedule_Mon').toString(),
                    this.$t('W_Schedule_Tue').toString(),
                    this.$t('W_Schedule_Wed').toString(),
                    this.$t('W_Schedule_Thu').toString(),
                    this.$t('W_Schedule_Fri').toString(),
                    this.$t('W_Schedule_Sat').toString(),
                ])[x.date.getDay()].text,
                value: x.date.getDate(),
                item: x,
            }
        })
    }

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    @Watch('monthMatrix')
    onMatrixChanged(newVal: Array<Array<calendar.DateItem>>) {
        this.$nextTick(() => {       
            this.scrollFitToToday();
        });
    }

    @Watch('currentDate')
    onCurrentDateChanged(newVal: calendar.DateItem) {
        this.scrollFitToToday()
    }

    scrollFitToToday() {
        if(this.dayWrap) {
            var todayElem = document.getElementsByClassName('date-select today')[0] as HTMLElement;
            if (todayElem)
            this.dayWrap.scrollLeft = todayElem.offsetLeft;
        }        
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    created() {
        this.$nextTick(() => {
            this.dayWrap = this.$refs.dayWrap as HTMLDivElement;
        });
    }
}
